import { type ComponentType, useState } from 'react';
import { getSession, type Session } from '@/api/session';
import { DevLogin } from '@/features/dev-login/dev-login';

/**
 * HOC that gates on DevLogin for standalone dev mode.
 * Renders DevLogin when no session exists, otherwise passes session to WrappedComponent.
 */
export function withDevLogin<P extends { session: Session }>(
  WrappedComponent: ComponentType<P>,
): ComponentType<Omit<P, 'session'>> {
  function WithDevLogin(props: Omit<P, 'session'>) {
    const [session, setSession] = useState<Session | null>(() => getSession());

    if (!session) {
      return <DevLogin onLogin={setSession} />;
    }

    return <WrappedComponent {...(props as P)} session={session} />;
  }

  WithDevLogin.displayName = `withDevLogin(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

  return WithDevLogin;
}
